module.exports = __webpack_public_path__ + "static/media/roses.912f5cbf.jpg";